module.exports = __webpack_public_path__ + "media/images/logo/logo-robokassa-73432aec1b9c3a321a6b87dad26bc0b5.png";